export default "{\n    \"activeCount_plural\": \"{{count}} habilidades activas\",\n    \"activeCount\": \"{{count}} habilidad activa\"\n}\n"